import React from 'react';

/**
 * Delta badge — shows up/down change with color + arrow.
 * Usage: <DeltaBadge value={8.3} suffix="% vs last month" />
 */
export default function DeltaBadge({ value, suffix = '', threshold = 0 }) {
    if (value === null || value === undefined || isNaN(value)) {
        return <span className="v3-delta neutral">—</span>;
    }
    const isUp = value > threshold;
    const isDown = value < threshold;
    const cls = isUp ? 'up' : isDown ? 'down' : 'neutral';
    const arrow = isUp ? '▲' : isDown ? '▼' : '●';
    const sign = value > 0 ? '+' : '';
    return <span className={`v3-delta ${cls}`}>{arrow} {sign}{value.toFixed(1)}{suffix}</span>;
}
